ReferenceInsertControl = require './reference_insert_control'
EDMSInsertControl = require './edms_insert_control'
GdtTableInsertControl = require './gdt_table/gdt_table_insert_control'
gdtTableNode = require './gdt_table/gdt_table_node'
GdtTableNodeView = require './gdt_table/gdt_table_node_view'
referenceNode = require './reference_node'
ReferenceNodeView = require './reference_node_view'
mediator = require 'mediator'
ThresholdPlotInsertControl = require './threshold_plot_insert_control'
NMAPrintoutTableInsertControl = require './nma_printout_table_insert_control'

{ createInsertControl } = Epiditor

showEdmsInsertControl = -> mediator.services.switches.isOn('edmsFeature')

module.exports = (exportMode = false, options = {}) ->
  { disabledFeatures, enabledFeatures, gdtTableOptions, questionType } = options
  canInsertThresholdPlot = mediator.services.switches.isOn('thresholdFeature') and
    questionType not in ['diagnostic', 'dx']
  GdtTableControl = (props) ->
    <GdtTableInsertControl {...props} {...gdtTableOptions} />

  {
    id: 'GdtInsertExtension'
    schema: {
      nodes: {
        reference: referenceNode
        gdtTable: gdtTableNode
      }
    }
    toolbarControls: _.compact([
      not _.contains(disabledFeatures, 'references') and
        createInsertControl(ReferenceInsertControl),
      _.contains(enabledFeatures, 'gdtTables') and not _.contains(disabledFeatures, 'gdtTables') and
        createInsertControl(GdtTableControl),
      canInsertThresholdPlot and
        createInsertControl(ThresholdPlotInsertControl),
      mediator.services.switches.isOn('thresholdFeature') and
        createInsertControl(NMAPrintoutTableInsertControl),
      showEdmsInsertControl() and not _.contains(disabledFeatures, 'edms') and
        createInsertControl(EDMSInsertControl)
    ])
    nodeViews: (portalsAPI) ->
      reference: (node, view, getPos) ->
        new ReferenceNodeView(node, view, getPos, portalsAPI, exportMode)
      gdtTable: (node, view, getPos) ->
        new GdtTableNodeView(node, view, getPos, portalsAPI, exportMode, gdtTableOptions)
  }
